<!--p;
w-->

<template>
    <div id="app">
        <Logo :color="getSecondaryColor()"></Logo>
        <Logout></Logout>
        <router-view></router-view>
        <Footer></Footer>
        <Spinner></Spinner>
        <BackgroundImage></BackgroundImage>
    </div>
</template>
<script>

    import Footer from './components//widget/Footer.vue'
    import Spinner from './components/widget/spinner.vue'
    import Logo from './components/widget/logo.vue'
    import BackgroundImage from './components/widget/backgroundImage.vue'
    import Logout from './components/widget/logout.vue'
    import $ from 'jquery';


    $.fn.goTo = function () {
        $('html, body').animate({
            scrollTop: $(this).offset().top + 'px'
        }, 'fast');
        return this; // for chaining...
    };


    export default {
        name: 'app',
        components: {
            Footer,
            Spinner,
            Logo,
            BackgroundImage,
            Logout
        },

        data: function () {
            return {

                time: 0,
                Delai:0

            }
        },
        created() {

        },

        mounted: function () {


            var _self = this;

            window.scrollTo(0, 0);
            window.onload = function () {

                _self.CreateStyle();

            }
            _self.GloablEvents();

        },
        methods: {
            GloablEvents: function () {
                $(document).ajaxStart(function () {
                    $("#spinner").show();
                })
                $(document).ajaxStop(function () {
                    setTimeout(function () {
                        $("#spinner").hide();
                    }, 200)
                })

            },
            addLight: function (color, amount) {
                let cc = parseInt(color, 16) + amount;
                let c = (cc > 255) ? 255 : (cc);
                c = (c.toString(16).length > 1) ? c.toString(16) : `0${c.toString(16)}`;
                return c;
            },
            LightColor: function (color, amount) {

                color = (color.indexOf("#") >= 0) ? color.substring(1, color.length) : color;
                amount = parseInt((255 * amount) / 100);
                return color = `#${this.addLight(color.substring(0, 2), amount)}${this.addLight(color.substring(2, 4), amount)}${this.addLight(color.substring(4, 6), amount)}`;

            },
            CreateStyle: function () {
                var currentJson = localStorage.getItem("user");
                if (!currentJson) return;

                var current_user = JSON.parse(currentJson);
                var colorPrimary = current_user.PrimaryColor;
                var colorWarning = current_user.WarningColor;

                //PRIMARY STYLE
                var styles = 'body,.btn.btn-primary,.bg-primary,.countdown,.ranking.ranking--primary ul li.first:before,.custom__radio input:checked + .custom__checkbox__label, .custom__checkbox input:checked + .custom__checkbox__label,.custom__radio input:checked + .custom__radio__label{ background-color: ' + colorPrimary + '!important;}';
                styles += '.text-primary,ul.list__questions li a h3,.ranking.ranking--primary h3{color:' + colorPrimary + '!important}';
                styles += 'ul.list__questions li,.custom__radio input:checked + .custom__checkbox__label, .custom__checkbox input:checked + .custom__checkbox__label,.custom__radio input:checked + .custom__radio__label{border-color:' + colorPrimary + '!important}';
                styles += '.btn.btn-primary:hover,.btn.btn-primary:focus,.btn.btn-primary:active,.ranking.ranking--primary ul li.second:before{background-color:' + this.LightColor(colorPrimary, 10) + '!important}';
                styles += '.ranking.ranking--primary ul li.tertiary:before{background-color: ' + this.LightColor(colorPrimary, 20) + '!important;}';

                // WARNING STYLE

                styles += '.btn.btn-warning,input, select, textarea,.bg-warning,h1.sep:after,.custom__radio input:checked + .custom__radio__label:after, .custom__checkbox input:checked + .custom__radio__label:after,.ranking.ranking--warning ul li.first:before,.custom__radio input:checked + .custom__checkbox__label:after, .custom__checkbox input:checked + .custom__checkbox__label:after{background-color:' + colorWarning + '!important;}';
                styles += '.text-warning,h1,.ranking.ranking--warning h3{color:' + colorWarning + '!important}';
                styles += '.custom__radio .custom__radio__label:before, .custom__checkbox .custom__radio__label:before,.custom__radio .custom__checkbox__label:before, .custom__checkbox .custom__checkbox__label:before{border-color:' + colorWarning + '!important;}';
                styles += '.btn.btn-warning:hover,.btn.btn-warning:focus,.btn.btn-warning:active,.ranking.ranking--warning ul li.second:before{background-color:' + this.LightColor(colorWarning, 10) + '!important}';
                styles += '.ranking.ranking--warning ul li.tertiary:before{background-color:' + this.LightColor(colorWarning, 20) + '!important}';
                var css = document.createElement('style');
                css.type = 'text/css';

                if (css.styleSheet)
                    css.styleSheet.cssText = styles;
                else
                    css.appendChild(document.createTextNode(styles));

                /* Append style to the tag name */
                document.getElementsByTagName("head")[0].appendChild(css);
            },
            IsLogged: function () {

                return (localStorage.getItem("user") && localStorage.getItem("user-token"));
            },
            LogOut: function () {
                var _self = this;
                localStorage.removeItem("user")
                localStorage.removeItem("user-token");
                try {
                    _self.$children[1].ShowLogOut = false;
                    _self.$router.push('/');
                    _self.$children[5].show = false;
                    _self.$children[5].Hide();
                    location.reload();

                } catch (e) {

                    location.reload();
                }

            },
            GotoReglement: function () {
                var _self = this;
                var CURRENT_USER = JSON.parse(localStorage.getItem("user"));
                var ch = parseInt(CURRENT_USER.Challenge);
                _self.$router.push('/Reglement/' + ch);
            },
            IsTesteur: function () {

                var CURRENT_USER = JSON.parse(localStorage.getItem("user"));
                return CURRENT_USER.Role === "TESTEUR";
            },
            GetPathImage: function (img) {
                var _self = this;
                if (!img) return "";
                var id = img.FkFile;
                return _self.GetPathFileId(id);
            },
            GetPathDocId: function (id) {
                var _self = this;
                var src = "";
                if (id && !isNaN(parseInt(id))) {
                    //return  _self.BASE_URL + "api/Images/Item/"+id
                    const user = localStorage.getItem('user-token');
                    let headers = {};

                    if (user) {
                        headers = { 'Authorization': 'Bearer ' + user };
                    }

                    const requestOptions = {
                        method: 'GET',
                        "crossDomain": true,
                        "data": {
                            "id": parseInt(id),
                        },
                        headers: headers,
                        async: false,
                        url: _self.BASE_URL + "api/Images/Document/"
                    }
                    $.ajax(requestOptions).done(function (response) {

                        src = `data:${response.ContentType};base64, ${response.FileContents}`;

                    });

                }
                else {
                    return "";
                }

                return src;
            },
            GetPathFileId: function (id) {
                var _self = this;
                var src = "";
                if (id && !isNaN(parseInt(id))) {
                    //return  _self.BASE_URL + "api/Images/Item/"+id
                    const user = localStorage.getItem('user-token');
                    let headers = {};

                    if (user) {
                        headers = { 'Authorization': 'Bearer ' + user };
                    }

                    const requestOptions = {
                        method: 'GET',
                        "crossDomain": true,
                        "data": {
                            "id": parseInt(id),
                        },
                        headers: headers,
                        async: false,
                        url: _self.BASE_URL + "api/Images/Item/"
                    }
                    $.ajax(requestOptions).done(function (response) {

                        src = `data:${response.ContentType};base64, ${response.FileContents}`;

                    });

                }
                else {
                    return "";
                }

                return src;
            },
            draw_next: function (step, ctx, canvas_size, center, radius) {

                var currentJson = localStorage.getItem("user");
                var colorWarning = "#ffb629";

                if (currentJson) {

                    var current_user = JSON.parse(currentJson);

                    colorWarning = current_user.WarningColor ? current_user.WarningColor : "#ffb629";
                }
                ctx.clearRect(0, 0, canvas_size[0], canvas_size[1]);
                if (step < 1) {
                    ctx.beginPath();
                    ctx.moveTo(center[0], center[1]);

                    ctx.arc(
                        center[0],
                        center[1],
                        radius,
                        Math.PI * (-0.5 + 0),
                        Math.PI * (-0.5 + step * 2),
                        true // INVERSER LES COULEURS
                    );

                    ctx.lineTo(center[0], center[1]);
                    ctx.closePath();
                    ctx.fillStyle = colorWarning; // color WARNING
                    ctx.fill();

                }

            },
            initCountDown: function (_delaiReponse, _nbrPoints) {

                var _self = this;
                _self.Delai = 0;
                _self.Compteur();

                var currentJson = localStorage.getItem("user");
                var colorPrimary = "rgb(51,178,186)";

                if (currentJson) {

                    var current_user = JSON.parse(currentJson);

                    colorPrimary = current_user.PrimaryColor ? current_user.PrimaryColor : "rgb(51,178,186)";
                }
                var canvas = document.getElementById('pie-countdown');
                if (window.G_vmlCanvasManager) {
                    window.G_vmlCanvasManager.initElement(canvas);
                }
                // num = document.getElementById('timeText'); <!-- TEMPS RESTANT -->
                var ctx = canvas.getContext('2d');
                var canvas_size = [canvas.width, canvas.height];
                var radius = Math.min(canvas_size[0], canvas_size[1]) / 2;
                var center = [canvas_size[0] / 2, canvas_size[1] / 2];
                // var start = 1; // varia de 1 até 0
                var fps = 40;
                var seconds = _delaiReponse; // ICI ON CHANGE LE TEMPS

                var total = fps * seconds;

                var deviation = (_delaiReponse / _nbrPoints);
                var to = seconds * 100;
                var st = deviation * 100;

                for (var i = 0; i <= to; i = i + st) {
                    var delayed = (function () {
                        var step = i;
                        return function () {
                            var points = parseInt($(".points").text());
                            _self.time = step;
                            if (points > 0) {
                                $(".points").html(parseInt(--points) + "</br>points");
                            }
                        };
                    })();
                    setTimeout(delayed, i * 10);
                }

                for (i = total; i >= 0; i--) {
                    var delayed2 = (function () {
                        var step = 1 - i / total;
                        //var left = Math.ceil(i / fps);
                        return function () {
                            //  num.innerHTML = left;<!-- TEMPS RESTANT -->
                            _self.draw_next(step, ctx, canvas_size, center, radius);
                        };
                    })();
                    setTimeout(delayed2, -1000 / fps * (i - total));
                }
                var canvasBackground = document.getElementById('pie-background');
                if (window.G_vmlCanvasManager) {

                    window.G_vmlCanvasManager.initElement(canvasBackground);
                }
                if (!canvasBackground) return;
                var context = canvasBackground.getContext('2d');
                var centerX = canvasBackground.width / 2;
                var centerY = canvasBackground.height / 2;
                // var radiusBackground = 70;
                context.beginPath();
                context.arc(centerX, centerY, radius, 0, 2 * Math.PI, false);
                context.fillStyle = colorPrimary; // color PRIMARY
                context.fill();
                context.lineWidth = 5;
                context.strokeStyle = colorPrimary;// color PRIMARY
                context.stroke();
            },
            getPrimaryColor: function () {
                var currentJson = localStorage.getItem("user");
                if (!currentJson) return 'orange';

                var current_user = JSON.parse(currentJson);
                return current_user.PrimaryColor;
            },
            getSecondaryColor: function () {
                var currentJson = localStorage.getItem("user");
                if (!currentJson) return 'orange';

                var current_user = JSON.parse(currentJson);
                return current_user.WarningColor;
            },
            Compteur: function () {
                var _self = this;
                _self.Delai = _self.Delai + 1;
                setTimeout(function () {
                    _self.Compteur();
                }, 1000);
            },
            IsParticipant: function () {
                try {
                   return  JSON.parse(localStorage.getItem("user")).Role === "PARTICIPANT";
                } catch (e) {
                    return false;
                }
                return false;
            }
        }
    }

</script>

<style lang="scss">
    @import '../src/assets/css/bootstrap.min.scss';
    @import './src/assets/css/main.scss';
</style>
<style>
    @font-face {
        font-family: 'hauracherell';
        src: url('./assets/fonts/hauracherell_nc-webfont-webfont.woff2') format('woff2'), url('./assets/fonts/hauracherell_nc-webfont-webfont.woff') format('woff');
        font-weight: normal;
        font-style: normal;
    }
</style>
<!---->
